import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/job/:jobId` | `${typeof baseRoute}/job/${number}?group=${string}&search=${string}&page=${string}`;

export type * from './viewModel';

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId`;

export const URL = (jobId: number, group: string, search: string, page: number): RouteDefinition => `${baseRoute}/job/${jobId}?group=${group}&search=${search}&page=${page}`;
